import { gql } from '@apollo/client';

export const GET_SECRET_CODE = gql`
  query GetSecretCode($id: ID!) {
    fantasyLeague(id: $id) {
      id
      secretCode
    }
  }
`;